import React, { useState } from 'react'
import { Link } from 'react-router-dom';

const CourseCard = ({card,color,index}) => {
    const [isHovered, setIsHovered] = useState(false);
  const circleStyle = { background: `${card.color ? card.color : "#FFFFFF24"}` };
  const imgStyle = { width: card?.width, height: card?.height };

    const currentImg = isHovered ? card?.hoverImg : card?.img;


  return (
     <div key={index} className="w-100"  onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
                 <div className={`course-card position-relative w-100 h-100 d-flex flex-column gap-4 ${isHovered ? 'hovered' : ''}`} style={{minHeight:card?.minHeight,"--hover-color":card.hoverColor}}>
                  <div className='d-flex align-items-center justify-content-between'>
                     <div
                     className="icon-circle"
                     style={circleStyle}
                   >
                   {currentImg && (
              <img src={currentImg} alt='skill-area' style={imgStyle} />
            )}
                   </div>

                      {card.badge && (
                      <div className='d-flex justify-content-end'>                       
                         <span className="py-1 px-2 rounded-1 FS14FW600" style={{color:'#686868',background: "#14141429",width:"fit-content"}}>
                           {card.badge}
                         </span>            
                      </div>)}
                  </div>
                 <div className='d-flex flex-column gap-1'>
                   <h3 style={{color:color}} className='FS18FW400 fw-600 m-0'>{card.title}</h3>
                   <p style={{color:color}} className='subtitle FS15FW400 plus-sans m-0 fw-500'>{card.text}</p>
                 </div>
                 {typeof card.link === "function" ? (
                   <button
                     type="button"
                     onClick={card.link}
                     className="greenText FS16FW500 fw-700 plus-sans m-0"
                     style={{ background: "none", border: "none", padding: 0, textAlign: "left", alignSelf: "flex-start",textDecoration:"underline" }}
                   >
                     {card?.btnText}
                     <img src='/images/web-new-images/new-green-arrow.png' alt='arrow' />
                   </button>
                 ) : (
                   <Link to={card.link} className="greenText FS16FW500 fw-700 plus-sans m-0">{card?.btnText}<img src='/images/web-new-images/new-green-arrow.png'/></Link>
                 )}
                 </div>     
               </div>
  )
}

export default CourseCard
